<div class="close-button" class="g-just-flex justify-content-end my-8 px-20"
    style="position: sticky; top: 0; background: transparent; z-index: 9999999;">
    <button mat-icon-button (click)="closeSelf()"
        style="width: 23px;
    height: 23px;   min-width: 20px;
    border-radius: 50%; background-color: var(--mat-sys-surface-variant); align-items: center !important; display: flex !important;" class="g-just-flex">
        <mat-icon style="font-size: 16px; height: 16px; width: 16px; color: var(--mat-sys-on-surface);">
            close</mat-icon>
    </button>
</div>
@if(existingReport && (existingReport.status ?? '').toString().toLowerCase() === 'final'){
<div class="m-20">
    <app-diagnostic-report-details [diagnosticReport]="existingReport"></app-diagnostic-report-details>
</div>
} @else if(toPassLabForm){<mat-stepper class="visible-overflow m-20">
    //new step for adding result or procedure
    @if(toReferenceResultsV2){
    <mat-step
        [label]="toReferenceResultsV2 === 'Observation' ? 'Add Results' : (toReferenceResultsV2 === 'ImagingStudy' ? 'Add Imaging Study' : 'Add Items')">
        <!--a check wheter to dedicate this step to imaging or observa-->
        <!-- a source of truth of wheher tehre is an existing observation -->
        @if(toReferenceResultsV2 === 'Observation' && serviceRequestIdsV2 && serviceRequestIdsV2.length > 0){
        <app-selected-obs [selectedObservations]="puttedObservationsV2" [serviceRequestIds]="serviceRequestIdsV2"
            [editable]="isEditableV2" (selectionChanged)="onObservationsSelectionChanged($event)">

        </app-selected-obs>
        }

        @if(toReferenceResultsV2 === 'ImagingStudy' && serviceRequestIdsV2 && serviceRequestIdsV2.length > 0){
        <app-selected-imaging-studies [selectedImagingStudies]="puttedImagingStudiesV2"
            [serviceRequestIds]="serviceRequestIdsV2" [patientId]="resolvedPatientIdV2" [editable]="isEditableV2"
            (selectionChanged)="onImagingStudiesSelectionChanged($event)">
        </app-selected-imaging-studies>
        }
        <div class="button-group my-15 g-just-flex " style="justify-content: flex-end; width: 100%; gap: 20px;">

            <button mat-flat-button matStepperNext>Next</button>

        </div>
    </mat-step>
    }

    @if(toReferenceResultsV2 === 'Observation' && serviceRequestIdsV2 && serviceRequestIdsV2.length > 0){
    <mat-step label="Select Specimen">
        <app-selected-specimens [selectedSpecimens]="selectedSpecimensV2" [serviceRequestIds]="serviceRequestIdsV2"
            [editable]="isEditableV2" (selectionChanged)="onSpecimensSelectionChanged($event)">

        </app-selected-specimens>
        <div class="button-group my-15 g-just-flex " style="justify-content: flex-end; width: 100%; gap: 20px;">
            <button mat-flat-button matStepperPrevious>Back</button>
            <button mat-flat-button matStepperNext>Next</button>

        </div>
    </mat-step>
    }

    <mat-step label="Items Required">
        <div class="mat-card-header mb-20">
            <div class="mat-mdc-card-title">Items Required</div>
            <div class="mat-mdc-card-subtitle subtitle-text-color-2 small-subtitle" style="line-height: 20px;">
                Review and edit the items required before filling the Diagnostic Report.
                @if(itemsRequiredSource === 'instance'){<span><b>Source:</b> Instance override</span>}
                @if(itemsRequiredSource === 'default'){<span><b>Source:</b> Default for this code</span>}
                @if(itemsRequiredSource === 'none'){<span><b>Source:</b> Not found</span>}
            </div>
        </div>

        @if(itemsRequiredReadOnlyNote){
        <div class="subtitle-text-color-2 small-subtitle"
            style="margin: 8px 0 14px; padding: 10px 12px; border: 1px solid var(--mat-sys-outline-variant); border-radius: 10px; background: var(--mat-sys-surface-container-highest);">
            {{ itemsRequiredReadOnlyNote }}
        </div>
        }

        @if(itemsRequiredLoading){
        <div class="subtitle-text-color-2 small-subtitle">Loading items required…</div>
        } @else {
        @if(!itemsRequiredForm || itemsRequiredForm.length === 0){
        <div class="subtitle-text-color-2 small-subtitle">Items required configuration is not available.</div>
        } @else {
        <!-- {{ itemsRequiredRows | json }} -->
        <app-resource-data-review
            [submittedData]="{itemsRequired: changeItemsRequiredRowsToResourceDataFormat(itemsRequiredRows)}"
            [resource]="{itemsRequired: changeItemsRequiredRowsToResourceDataFormat(itemsRequiredRows)}"
            [formFields]="itemsRequiredForm" [showEditButtons]="isEditableV2 && itemsRequiredEditEnabled"
            (resourceUpdated)="onItemsRequiredUpdatedFromReview($event)">
        </app-resource-data-review>
        }
        }

        <div class="button-group my-15 g-just-flex " style="justify-content: flex-end; width: 100%; gap: 20px;">
            <button mat-flat-button matStepperPrevious>Back</button>
            <button mat-flat-button matStepperNext>Next</button>

        </div>
    </mat-step>

    <mat-step label="Add Report">

        <div class="mat-card-header mb-20">
            <div class="mat-mdc-card-title">Add Report</div>
            <div class="mat-mdc-card-subtitle ">Add a report for the lab tests done
            </div>
        </div>

        @if(existingReport && (existingReport.status ?? '').toString().toLowerCase() === 'final'){
        <div class="subtitle-text-color-2 small-subtitle"
            style="margin: 8px 0 14px; padding: 10px 12px; border: 1px solid var(--mat-sys-outline-variant); border-radius: 10px; background: var(--mat-sys-surface-container-highest);">
            This report is <b>FINAL</b> and is read-only.
        </div>

        <app-diagnostic-report-details [diagnosticReport]="existingReport"></app-diagnostic-report-details>
        } @else {

        @if(existingReport && !isEditableV2){
        <div class="subtitle-text-color-2 small-subtitle"
            style="margin: 8px 0 14px; padding: 10px 12px; border: 1px solid var(--mat-sys-outline-variant); border-radius: 10px; background: var(--mat-sys-surface-container-highest);">
            This report is <b>{{ existingReport.status }}</b> and is not editable.
        </div>
        }

        @if(diagnosticReportUiMode === 'form'){
        <app-dynamic-forms-v2 [formFields]="diagnosticReportFormFieldsWithoutAttachments" [formMetaData]="undefined"
            #formCmp (onEveryChange)="onDiagnosticReportFormChanged($event)">
        </app-dynamic-forms-v2>

        <div class="button-group my-15 g-just-flex " style="justify-content: flex-end; width: 100%; gap: 20px;">
            <button mat-flat-button (click)="switchDiagnosticReportToReview()">Review</button>
        </div>
        } @else {
        <app-resource-data-review [resource]="diagnosticReportWorking"
            [formFields]="diagnosticReportFormFieldsWithoutAttachments" [showEditButtons]="isEditableV2"
            [mapResourceToSubmittedData]="mapDiagnosticReportToSubmittedData"
            [applySubmittedDataToResource]="applySubmittedDataToDiagnosticReport"
            (resourceUpdated)="onDiagnosticReportWorkingUpdated($event)">
        </app-resource-data-review>

        @if(isEditableV2){
        <div class="button-group my-15 g-just-flex " style="justify-content: flex-end; width: 100%; gap: 20px;">
            <button mat-flat-button (click)="switchDiagnosticReportToForm()">Back to Form</button>
        </div>
        }
        }

        }

        <div class="mt-20">
            <div class="mat-mdc-card-title">Attachments</div>
            <div class="mat-mdc-card-subtitle subtitle-text-color-2 small-subtitle" style="line-height: 20px;">
                Manage report documents/files saved in <b>DiagnosticReport.presentedForm</b>.
            </div>

            @if(isEditableV2){
            <div class="mt-10">
                <app-upload-ui [maxFiles]="5" [existingFiles]="existingAttachmentFilesForUploadUi"
                    (filesChanged)="onAttachmentFilesChangedFromUploadUi($event)"></app-upload-ui>
            </div>
            }

            @if((diagnosticReportWorking?.presentedForm ?? []).length > 0){
            <div class="mt-10" style="display: flex; flex-direction: column; gap: 10px;">
                @for(att of (diagnosticReportWorking.presentedForm ?? []); track ($index)){
                @let url = (att?.url ?? att?.fileLink);
                <div
                    style="padding: 10px 12px; border: 1px solid var(--mat-sys-outline-variant); border-radius: 10px; background: var(--mat-sys-surface-container-highest);">
                    <div class="g-just-flex"
                        style="justify-content: space-between; gap: 12px; align-items: center; flex-wrap: wrap;">
                        <div style="flex: 1 1 320px; min-width: 280px;">
                            <div class="subtitle-text-color-2 small-subtitle" style="margin-bottom: 6px;">Title</div>
                            <input matInput [value]="att?.title ?? att?.uploadFileName ?? ''" [disabled]="!isEditableV2"
                                (input)="updateAttachmentTitleAtIndex($index, ($any($event.target).value))"
                                placeholder="Attachment title" />
                            <div class="subtitle-text-color-2 small-subtitle"
                                style="margin-top: 6px; word-break: break-all;">
                                @if(url){
                                <a [href]="url" target="_blank" rel="noopener">Open</a>
                                } @else {
                                <span>Embedded attachment (no URL)</span>
                                }
                            </div>
                        </div>

                        @if(isEditableV2){
                        <button mat-stroked-button color="warn"
                            (click)="removeAttachmentAtIndex($index)">Remove</button>
                        }
                    </div>
                </div>
                }
            </div>
            }
        </div>

        @if(false){
        <div class="mt-20">
            <div class="mat-mdc-card-title">Attach Files (no cloud)</div>
            <div class="mat-mdc-card-subtitle subtitle-text-color-2 small-subtitle" style="line-height: 20px;">
                Upload files locally. Selected files are saved into <b>DiagnosticReport.presentedForm</b> as base64.
            </div>
            <app-imaging-study-images (imagesChanged)="reportImages = $event" (cloudFiles)="onAttachmentFilesChangedFromUploadUi($event)"></app-imaging-study-images>
        </div>
        }

        <div class="button-group my-15 g-just-flex " style="justify-content: flex-end; width: 100%; gap: 20px;">
            <button mat-flat-button matStepperPrevious>Back</button>
            @if(isEditableV2){
            <button mat-flat-button (click)="saveReport('draft')">Save Draft</button>
            <button mat-flat-button (click)="saveReport('final')">Save Final</button>
            }

        </div>
        <!-- <div class="button-group my-15 g-just-flex " style="justify-content: flex-end; width: 100%; gap: 20px;"> -->



    </mat-step>
    <!--  <mat-step label="References">
        <div class="mat-card-header mb-20">
            <div class="mat-mdc-card-title">Observation and Specimen References</div>
            <div class="mat-mdc-card-subtitle subtitle-text-color-2 small-subtitle" style="line-height: 20px;">
                Add Observation and Specimen References for this report. You'll find some references already
                added. You can delete them and also add new ones.
            </div>
        </div>

        <div class="observation-section" style="width: max-content; max-width: 100%;">
            <div class="g-just-flex justify-content-between flex-wrap mb-20"
                style="width: 100%; justify-content: flex-start; gap: 13px;">
                <div class="mat-mdc-card-title">Observation</div>
                <button mat-button (click)="addObservationReference()">
                    <mat-icon>add</mat-icon>
                    Add Observation</button>
            </div>
            <div class="g-just-flex gap-25 flex-wrap justify-content-start">
                @for(ref of selectedObservationRefs; track ref.reference; let i = $index){
                <div class="each-reference g-just-flex gap-30" #td>
                    <app-reference-display [data]="ref"
                        [referenceDeepPath]="[['code','coding', '0', 'display'].join('$#$')]" [tdReference]="td"
                        (tdClicked)="raiseTd($event)">
                    </app-reference-display>
                    <div class="rounded-icon-wrapper" (click)="removeObservationReference(i)">
                        <mat-icon>delete</mat-icon>
                    </div>
                </div>
                }


            </div>
        </div>


        <div class="observation-section mt-30 pt-20" style="width: max-content; max-width: 100%;">
            <div class="g-just-flex justify-content-between flex-wrap mb-20"
                style="width: 100%; justify-content: flex-start; gap: 13px;">
                <div class="mat-mdc-card-title">

                    Specimen
                </div>
                <button mat-button (click)="addSpecimenReference()">
                    <mat-icon>add</mat-icon>
                    Add Specimen</button>
            </div>
            <div class="g-just-flex gap-25 flex-wrap justify-content-start">
                @for(ref of selectedSpecimenRefs; track ref.reference; let i = $index){
                <div class="each-reference g-just-flex gap-30">
                    <app-reference-display [data]="ref"
                        [referenceDeepPath]="[['type','coding', '0', 'display'].join('$#$')]"></app-reference-display>
                    <div class="rounded-icon-wrapper" (click)="removeSpecimenReference(i)">
                        <mat-icon>delete</mat-icon>
                    </div>
                </div>
                }


            </div>
        </div>
        <div class="button-group my-15 g-just-flex " style="justify-content: flex-end; width: 100%; gap: 20px;">
            <button mat-flat-button (click)="saveReport()">Save</button>


        </div>
    </mat-step> -->
</mat-stepper>
}